import { DateTime } from "luxon";
import {
  ChangeRequestStatus,
  type ChangeRequestChange,
  type Node
} from "@/pages/sections/[sectionId]/change-requests/queries";
import { formatChangeRequestType, visibleChanges } from "@/pages/sections/[sectionId]/change-requests/_utils";

export function getChangeRequestPersonName(person: Node["person"]): string {
  return `${person.firstName} ${person.lastName}`.trim();
}

export function getChangeRequestInitials(person: Node["person"]): string {
  const initials = [person.firstName, person.lastName].map((name) => name?.trim()[0]?.toUpperCase() ?? "").join("");

  return initials || "CR";
}

export function formatChangeRequestRecencyLabel(submittedAt: string): string | null {
  const parsed = DateTime.fromISO(submittedAt, { setZone: true });

  if (!parsed.isValid) {
    return null;
  }

  return parsed.toLocal().toRelative({ base: DateTime.now() });
}

export function formatChangeRequestSummary(change: ChangeRequestChange, status: ChangeRequestStatus): string {
  const fields = visibleChanges(change, status);
  const titleField = fields.find((field) => field.id === "title");

  if (titleField?.existing && titleField.requested && titleField.existing !== titleField.requested) {
    return `${titleField.existing} → ${titleField.requested}`;
  }

  if (titleField?.requested && !titleField.existing) {
    return titleField.requested;
  }

  const classificationField = fields.find((field) => field.id === "classification");
  if (classificationField?.requested) {
    return classificationField.requested;
  }

  const descriptionField = fields.find((field) => field.id === "description");
  if (descriptionField?.requested) {
    return descriptionField.requested;
  }

  return formatChangeRequestType(change.__typename);
}
